import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import ResultadoMotorCreditoList from './ResultadoMotorCreditoList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import ResultadoMotorCreditoCadastrar from './ResultadoMotorCreditoCadastrar';
import { Messages } from 'primereact/messages';
import postResultadoMotorCredito from '../../service/postResultadoMotorCredito';
import putResultadoMotorCredito from '../../service/putResultadoMotorCredito';

export default function ResultadoMotorCreditoPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [resultadoMotorCredito, setResultadoMotorCredito] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveResultadoMotorCredito = (resultadoMotorCredito:any) => {
    if(resultadoMotorCredito.id){
      putResultadoMotorCredito(resultadoMotorCredito).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setResultadoMotorCredito(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postResultadoMotorCredito(resultadoMotorCredito).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setResultadoMotorCredito(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setResultadoMotorCredito({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-align-left" style={{ fontSize: '2.0rem' }}></i> {t('resultadoMotorCredito')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!resultadoMotorCredito && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <ResultadoMotorCreditoList onEdit={(resultadoMotorCredito:any) => { setResultadoMotorCredito(resultadoMotorCredito);}}></ResultadoMotorCreditoList>
          </>
        )}
        {resultadoMotorCredito && (
          <>
           <ResultadoMotorCreditoCadastrar msgs={msgs} resultadoMotorCredito={resultadoMotorCredito} onSave={saveResultadoMotorCredito} onClose={() => {setResultadoMotorCredito(null)}}></ResultadoMotorCreditoCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
